import { useTranslation } from 'react-i18next'
import PageHeader from '../../components/ui/PageHeader'
import ActionsListPanel from './components/ActionsListPanel'
import '../minutes/minutes.css'

/**
 * Arşivlenen Aksiyonlar (analiz 8.4/8.5) — <b>salt-okuma</b> liste. Aktif Aksiyonlar ekranının birebir görünümü
 * (arama + önem/durum filtresi + sıralama + sayfalama), ancak yalnız <b>Arşivlendi</b> ve <b>İptal</b> statüsündeki
 * aksiyonlar listelenir ({@code ActionsListPanel archived}). Satır → Aksiyon Detay (arşiv rotasında, read-only).
 */
export default function MinutesArchivedActionsPage() {
  const { t } = useTranslation()
  return (
    <div className="page minutes-page">
      <PageHeader title={t('actions.archived.title')} />
      <ActionsListPanel scope="all" archived />
    </div>
  )
}
